<template>
	<b-container fluid>
		<b-card
			class="m-4"
			:header="
				$route.query.internar
					? 'Registrar entrada'
					: 'Registrar saída/Editar'
			"
			header-text-variant="white"
			header-tag="header"
			header-bg-variant="success"
			footer-tag="footer"
		>
			<b-card-text>
				<b-form>
					<b-row>
						<b-col>
							<b-form-group
								id="dormitorio-form-group"
								label="Dormitório"
								label-for="dormitorio"
							>
								<b-form-select
									id="dormitorio"
									name="dormitorio"
									v-model="internacao.dormitorio"
									aria-describedby="dormitorio-feedback"
									:disabled="
										this.$route.params.dormitorio_id !=
											undefined
									"
								>
									<template v-slot:first>
										<b-form-select-option
											:value="null"
											disabled
											>-- Selecione o dormitório
											--</b-form-select-option
										>
									</template>
									<b-form-select-option
										v-for="dormitorio in dormitorios"
										:key="dormitorio.id"
										:value="dormitorio"
										>{{
											dormitorio.descricao
										}}</b-form-select-option
									>
								</b-form-select>

								<b-form-invalid-feedback
									id="tipo-refeicao-feedback"
									>Escolha um
									dormitório.</b-form-invalid-feedback
								>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								id="perfil-form-group"
								label="Perfil"
								label-for="perfil"
							>
								<b-form-select
									id="perfil"
									name="perfil"
									v-model="internacao.perfil"
									aria-describedby="perfil-feedback"
									:state="
										$v.internacao.perfil.$error
											? false
											: null
									"
								>
									<template v-slot:first>
										<b-form-select-option
											:value="null"
											disabled
											>-- Selecione o perfil
											--</b-form-select-option
										>
									</template>
									<b-form-select-option
										v-for="perfil in perfis"
										:key="perfil.id"
										:value="perfil"
										>{{
											perfil.descricao
										}}</b-form-select-option
									>
								</b-form-select>

								<b-form-invalid-feedback
									id="tipo-refeicao-feedback"
									>Escolha um
									dormitório.</b-form-invalid-feedback
								>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group
								id="nome-form-group"
								label="Usuária"
								label-for="nome"
							>
								<b-form-input
									v-model="internacao.nome"
									id="nome"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group
								id="ig-form-group"
								label="Idade gestacional"
								label-for="ig"
							>
								<b-form-input
									v-model="internacao.ig"
									id="ig"
								></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								id="diagnostico-form-group"
								label="Diagnóstico"
								label-for="diagnostico"
							>
								<b-form-input
									v-model="internacao.diagnostico"
									id="diagnostico"
								></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-form-group
								id="dthr_internacao-form-group"
								label="Data de entrada"
								label-for="data-inicio"
							>
								<date-picker
									v-model="internacao.dthr_internacao"
									:config="datetimeOptions"
								></date-picker>

								<b-form-invalid-feedback
									id="dthr_internacao-feedback"
									>Escolha a data da
									internação.</b-form-invalid-feedback
								>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group
								id="dthr_alta-form-group"
								label="Data de saída"
								label-for="data-inicio"
							>
								<date-picker
									v-model="internacao.dthr_alta"
									:config="datetimeOptions"
								></date-picker>

								<b-form-invalid-feedback id="dthr_alta-feedback"
									>Escolha a data da
									internação.</b-form-invalid-feedback
								>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col>
							<b-form-group
								id="observacao-form-group"
								label="Observação"
								label-for="observacao"
							>
								<b-form-textarea
									id="observacao"
									name="observacao"
									v-model="internacao.observacao"
									class="mb-3"
								></b-form-textarea>
							</b-form-group>
						</b-col>
					</b-row>
				</b-form>
			</b-card-text>
			<template v-slot:footer>
				<b-container id="rodape" fluid>
					<b-row>
						<b-col>
							<b-button variant="success" @click="salvar" :disabled="isButtonDisabled"
								>Salvar</b-button
							>
							<b-button
								class="ml-2"
								variant="danger"
								to="/casadagestante/censo"
								>Cancelar</b-button
							>
						</b-col>
					</b-row>
				</b-container>
			</template>
		</b-card>
	</b-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import mixinToast from "@/mixins/mixinToast.js";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
	mixins: [mixinToast],
	components: { datePicker },
	data() {
		return {
			datetimeOptions: {
				sideBySide: true,
				locale: "pt-BR",
			},
			internacao: {
				id: null,
				ig: null,
				dormitorio: null,
				dthr_internacao: null,
				diagnostico: null,
				dthr_alta: null,
				perfil: null,
				nome: null,
				observacao: "",
			},
			dormitorios: null,
			perfis: null,
			isButtonDisabled: false
		};
	},
	validations: {
		internacao: {
			dormitorio: {
				required,
			},
			dthr_internacao: {
				required,
			},
			perfil: {
				required,
			},
			nome: {
				required,
			},
		},
	},
	methods: {
		getDormitorios() {
			this.$http.get("/dormitorio?filter=").then((response) => {
				this.dormitorios = response.data;
				if (this.$route.params.dormitorio_id) {
					this.internacao.dormitorio = this.dormitorios.filter(
						(el) => {
							return el.id == this.$route.params.dormitorio_id;
						}
					)[0];
					this.getInternacao();
				}
			});
		},
		getInternacao() {
			this.$http
				.get(
					`/internacaopordormitorio?dormitorio_id=${this.$route.params.dormitorio_id}`
				)
				.then((response) => {
					if (response.data != null) {
						console.log(response.data);
						console.log(response.data.dormitorio.id);
						console.log(this.dormitorios);
						this.internacao = response.data;
						this.internacao.dormitorio = this.dormitorios.filter(
							(el) => {
								return el.id == response.data.dormitorio.id;
							}
						)[0];
						this.internacao.perfil = this.perfis.filter((el) => {
							return el.id == response.data.perfil.id;
						})[0];
						this.internacao.dthr_internacao = new Date(
							response.data.dthr_internacao
						);
					}
				});
		},
		getPerfis() {
			this.$http
				.get("/casadagestante/perfil?filter=")
				.then((response) => {
					this.perfis = response.data;
				});
		},
		salvar() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.$bvModal
					.msgBoxConfirm("Deseja salvar?", {
						title: "Confirmação?",
						okVariant: "success",
						okTitle: "Sim",
						cancelTitle: "Não",
						footerClass: "p-2",
						hideHeaderClose: false,
						centered: true,
					})
					.then((value) => {
						if (value) {
							this.isButtonDisabled = true
							this.$http
								.post("/internacao", this.internacao)
								.then((response) => {
									this.exibeToast(
										response.data.success,
										response.data.message
									);
									this.internacao.id = response.data.id
									this.isButtonDisabled = false
								})
								.catch((error) => {
									console.log(error);
									this.isButtonDisabled = false
								});
						}
					});
			} else {
				console.log(this.$v);
			}
		},
	},
	mounted() {
		this.getPerfis();
		this.getDormitorios();
		console.log(this.$route);
		// if (this.$route.params.id) {
		// 	this.$http
		// 		.get("/autorizacoesrefeicoes/" + this.$route.params.id)
		// 		.then((result) => {
		// 			this.autorizacao = result.data;
		// 			this.autorizacao.tipoRefeicao = this.autorizacao.tipoderefeicao;
		// 			console.log(this.autorizacao);
		// 		});
		// }
	},
};
</script>

<style></style>
